import React from 'react';
import { QuestionOptionClick,onRadio } from './../../containers/buildProduct/helperContent';
import { connect } from 'react-redux'
import Button from './../../components/button';
import { closeModalWindow, closeCancelWindow } from './../../action/modalWindow'

class CustomTvQuestions extends React.PureComponent {
    constructor(props) {
        super();
        props.dispatch({ type: 'PUSH_QUESTION', value: props.CustomTvJson });
    }
    onOpenModal =()=>{
        if (this.props.cTV_Recom.recommendedTV === "PREFERRED") {
            this.props.dispatch({ type: 'CUSTOMTV_PREFERRED_RECOMM', value: '' });
        }else if(this.props.cTV_Recom.recommendedTV !== ""){            
            this.props.dispatch({ type: 'CUSTOMTV_RECOMM', value: '' });
        }
        closeModalWindow('HELPCUSTOMTV', this.props.dispatch);
    }
    
    checkboxChecked = (tvRecommendationChecked, id) => {
        if ((tvRecommendationChecked.indexOf("Q10") !== -1 || tvRecommendationChecked.indexOf("Q11") !== -1) && id === "Q1") {
            return false;
        } else {
            return (tvRecommendationChecked.indexOf(id) > -1)
        }
    }
    onOpenCancel = ()=>{
        closeCancelWindow('HELPCUSTOMTV', this.props.dispatch);
    }

    render() {
        let dispatch = this.props.dispatch;
        let title = this.props.title || this.props.CustomTvJson.Title;
        let questions = "";
        let combinations = '';

        if (this.props.cTV_Recom.questionArray !== undefined && this.props.cTV_Recom.questionArray !== null && this.props.cTV_Recom.questionArray.length > 0) {
            combinations = this.props.cTV_Recom.questionArray.map(quesComb=>{                
                if (quesComb.Question.length > 2) {
                questions = quesComb.Question.map(ques=>{
                    return (
                        <React.Fragment><span class="" id="CustomQuestionOption1">
                            <input class="value" type="checkbox" checked={this.checkboxChecked(this.props.cTV_Recom.tvRecommendationChecked, ques.id)/*this.props.cTV_Recom.tvRecommendationChecked.indexOf(ques.id)>-1*/ } onChange={(e) => QuestionOptionClick(e, dispatch, this.props.cTV_Recom.tvRecommendationChecked, this.props.cTV_Recom)} id={ques.id} qid={ques.id} />
                            <label role="checkbox" for={ques.id} ><span class="optname">{ques.text}</span></label>
                        </span>
                            <br></br>
                        </React.Fragment>
                    )
                })
                } else if (quesComb.Question.length === 2) {
                    questions = quesComb.Question.map(ques=>{
                        return (
                            <React.Fragment><span class="" id="CustomQuestionOption1">
                                <input type="radio" class="value" checked={this.props.cTV_Recom.radioChecked === ques.id} onChange={(e) => onRadio(e,dispatch,this.props.cTV_Recom.radioChecked,this.props.cTV_Recom.tvRecommendationChecked, this.props.cTV_Recom)} id={ques.id} qid={ques.id} />
                                <label aria-required="false" aria-checked="true" role="radio" for={ques.id} ><span class="optname">{ques.text}</span></label>
                            </span>
                            <br></br>
                            </React.Fragment>
                        )
                    })
                }
                return (<div id="dvFirstQues">
                <div class="bg-grey-6 margin-horiz-tiny padding-all-tiny" data-type="program" id="CustomQuestion1">
                    <p class="margin-bottom-tiny">
                        {quesComb.Title|| 'Are either of these types of programming, must haves for your household?'}
                    </p>
                    {questions}
                </div>
            </div>)
            })

        }
        else {
            if (this.props.CustomTvJson.Question.length > 2) {
            questions = this.props.CustomTvJson.Question.map(ques => {
                return (
                    <React.Fragment><span class="" id="CustomQuestionOption1">
                        <input class="value" type="checkbox" onChange={(e) => QuestionOptionClick(e, dispatch, this.props.cTV_Recom.tvRecommendationChecked,this.props.cTV_Recom)} id={ques.id} qid={ques.id} />
                        <label aria-required="false" aria-checked="true" role="checkbox" for={ques.id} ><span class="optname">{ques.text}</span></label>
                    </span>
                        <br></br>
                    </React.Fragment>
                )
            });
            }
            else if (this.props.CustomTvJson.Question.length === 2) {
                questions = this.props.CustomTvJson.Question.map(ques=>{
                    return (
                        <React.Fragment><span class="" id="CustomQuestionOption1">
                            <input type="radio" class="value" checked={this.props.cTV_Recom.radioChecked === ques.id} onChange={(e) => onRadio(e,dispatch,this.props.cTV_Recom.radioChecked,this.props.cTV_Recom.tvRecommendationChecked,this.props.cTV_Recom)} id={ques.id} qid={ques.id} />
                            <label aria-required="false" aria-checked="true" role="radio" for={ques.id} ><span class="optname">{ques.text}</span></label>
                        </span>
                        </React.Fragment>
                    )
                })
            }

            combinations = <div id="dvFirstQues">
                <div class="bg-grey-6 margin-horiz-tiny padding-all-tiny" id="CustomQuestion1">
                    <p class="margin-bottom-tiny">
                        {title}
                    </p>
                    {questions}
                </div>
            </div>
        }
        return (

            <React.Fragment>
                {combinations}
                <div className="modal_footer">
                <div className={this.props.cTV_Recom.recommendedTV === "PREFERRED" ? "" : "hide"}><p style={{color: 'red'}}>We're sorry. Our Custom TV packages don't seem to fit your programming needs. We suggest checking out the Preferred HD channel line up.</p></div>
                <Button buttonText="Cancel" buttonStyle="button secondary left medium-p-auto BrandFontText text-center margin-top-zero" onClick={this.onOpenCancel} />
                <Button buttonText={this.props.cTV_Recom.recommendedTV === "PREFERRED" ? "See other TV plans" : "See Recommendation"} buttonStyle="button right medium-p-auto BrandFontText text-center margin-top-zero" disableButton={!this.props.cTV_Recom.enableButton} onClick={this.onOpenModal}/>
            </div>
            </React.Fragment>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        cTV_Recom: state.customTvRecommendation
    }
}

export default connect(
    mapStateToProps,
)(CustomTvQuestions);